import { useEffect } from 'react';
import { getInboxClient } from '@repletoryreach/sdk-realtime';
import type { TemplateEvents } from '@repletoryreach/sdk-realtime';
import { useRealtimeStore } from '@repletoryreach/sdk-utils/store';

/**
 * Typed subscription to W4b's template-lifecycle events. They ride the inbox
 * hub today (one connection per tenant). The library's `useInboxEvent` is
 * typed only against `InboxEvents`, so we go through `getInboxClient().on()`
 * which accepts the union `InboxEvents & TemplateEvents`.
 */
export function useTemplateEvent<E extends keyof TemplateEvents & string>(
  event: E,
  handler: (payload: TemplateEvents[E]) => void
): void {
  const status = useRealtimeStore((s) => s.status);
  useEffect(() => {
    const client = getInboxClient();
    if (!client) return;
    return client.on(event as never, handler as never);
  }, [event, handler, status]);
}
